import styled from 'styled-components';

//components
import { Container } from '@/components/Grid';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const FormSection = styled.section`
  background: ${homeColor.bg2};
  padding: 50px 0;

  ${screen.md} {
    padding: 60px 0;
  }

  ${screen.lg} {
    padding: 80px 0;
  }

  ${screen.xxlg} {
    padding: 100px 0;
  }
`;

export const FormInner = styled(Container)`
  display: flex;
  flex-direction: column;
  gap: 40px;

  ${screen.md} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
  }

  ${screen.lg} {
    gap: 60px;
  }
`;

export const FormCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${screen.md} {
    flex-shrink: 0;
    width: 330px;
  }

  ${screen.lg} {
    width: 489px;
  }
`;

export const FormTitle = styled.h2`
  font-family: ${getToken('font-family-title')};
  font-weight: 800;
  line-height: 1.25;
  font-size: 26px;
  margin: 0;
  text-align: center;

  ${screen.md} {
    text-align: left;
  }

  ${screen.lg} {
    font-size: 38px;
  }

  ${screen.xxlg} {
    font-size: 48px;
  }
`;

export const FormSubtitle = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5;
  color: ${homeColor.muted};
  margin: 0;

  text-align: center;

  ${screen.md} {
    text-align: left;
  }

  ${screen.lg} {
    font-size: 20px;
  }

  ${screen.xxlg} {
    font-size: 26px;
  }
`;

export const FormFieldsWrap = styled.div`
  width: 100%;

  ${screen.md} {
    width: 330px;
  }

  ${screen.lg} {
    width: 440px;
  }

  ${screen.xxlg} {
    width: 550px;
  }
`;

export const HubspotFormContainer = styled.div`
  margin: auto;
  width: 100%;
  color: ${homeColor.white};

  [data-hsfc-id='Renderer'] .hsfc-RichText p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    color: ${homeColor.white};
  }

  label,
  legend,
  [data-hsfc-id='Renderer'] .hsfc-FieldLabel {
    margin: 4px 0 0;
    display: inline-block;

    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    color: ${homeColor.white};
  }

  legend {
    font-size: 14px;
    line-height: 20px;
  }

  fieldset,
  [data-hsfc-id='Renderer'] .hsfc-Row {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    max-width: 510px !important;

    ${screen.md} {
      flex-direction: row;
    }
  }

  .input {
    margin: 0 !important;
  }

  .hs-form-field {
    margin-bottom: 16px;
    width: 100% !important;

    ${screen.md} {
      width: 50%;

      &:nth-child(2) {
        padding-left: 12px;
      }
    }
  }

  input[type='text'],
  input[type='email'],
  input[type='tel'],
  input[type='url'],
  input[type='number'],
  select,
  textarea,
  [data-hsfc-id='Renderer'] .hsfc-DropdownOptions__List__ListItem,
  [data-hsfc-id='Renderer'] .hsfc-TextareaInput {
    width: 100% !important;
    height: 48px;

    border: 1px solid #fff;
    border-radius: 3px;

    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    color: rgb(${getToken('color-text-primary')});
    padding: 4px 8px;
  }

  ,
  [data-hsfc-id='Renderer'] .hsfc-DropdownField,
  .hsfc-EmailField,
  .hsfc-PhoneField,
  .hsfc-TextField,
  .hsfc-TextareaField,
  .hsfc-TextField {
    width: 100% !important;
  }

  textarea,
  [data-hsfc-id='Renderer'] .hsfc-TextareaInput {
    height: unset;
    min-height: 48px;
  }

  input[type='submit'],
  [data-hsfc-id='Renderer'] .hsfc-Button:not([disabled]) {
    display: inline-flex;
    width: fit-content;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 14px;
    width: 100%;

    font-family: ${getToken('platform-font-default')};
    color: rgb(${getToken('color-text-primary')});
    font-size: 16px;
    line-height: 16px;
    font-weight: ${getToken('font-weight-medium')};
    text-transform: none;

    background: rgb(${getToken('color-brand')});
    border: 2px solid rgb(${getToken('color-brand')});

    border-radius: 4px;
    transition: all 0.1s ease-in-out;

    cursor: pointer;

    &:hover,
    &:active {
      background: rgb(${getToken('color-primary-60')});
      border-color: rgb(${getToken('color-primary-60')});
      transition: all 0.2s ease-in-out;
      color: rgb(${getToken('color-text-inverted')});
    }

    &:focus {
      outline: 1px solid rgb(${getToken('color-primary-60')});
    }
  }

  ul.inputs-list {
    list-style: none;
    padding: 0;
    margin: 10px 0;
  }

  .submitted-message {
    text-align: center;
    padding: 20px;
    font-size: 18px;

    ${screen.md} {
      font-size: 26px;
    }
  }

  .hs-error-msgs {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      .hs-main-font-element,
      .hs-error-msg {
        font-size: 14px;
        line-height: 18px;
        margin: 8px 0;
        color: rgb(${getToken('color-text-error')});
      }
    }
  }

  .hsfc-InfoAlert .hsfc-LinkButton {
    color: rgb(${getToken('color-text-highlight')});
  }

  [data-hsfc-id='Renderer'] .hsfc-ErrorAlert {
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 14px;
    line-height: 18px;
    margin: 8px 0;
    color: rgb(${getToken('color-text-error')});
  }
`;

export const DisclaimerWrapper = styled.div`
  padding: 20px 0 0;
  font-size: 12px;
  line-height: 16px;
  color: ${homeColor.muted2};
  text-align: justify;

  a {
    text-decoration: underline;
    color: inherit;
  }
`;
